import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["popup", "accept", "refuse"];

  connect() {
    this.consentPropertyName = "cookie_consent";
    this.storageType = this.cookieStorage;

    this.handleAccept = this.acceptCookies.bind(this);
    this.handleRefuse = this.hidePopup.bind(this);

    if (this.shouldShowPopup()) {
      this.showPopup();
    }

    this.acceptTarget.addEventListener("click", this.handleAccept);
    this.refuseTarget.addEventListener("click", this.handleRefuse);
  }

  disconnect() {
    this.acceptTarget.removeEventListener("click", this.handleAccept);
    this.refuseTarget.removeEventListener("click", this.handleRefuse);
  }

  showPopup() {
    setTimeout(() => {
      this.popupTarget.classList.remove("hidden");
    }, 2000);
  }

  hidePopup() {
    this.popupTarget.classList.add("hidden");
  }

  acceptCookies() {
    this.saveToStorage();
    this.hidePopup();
  }

  shouldShowPopup() {
    return !this.storageType.getItem(this.consentPropertyName);
  }

  saveToStorage() {
    this.storageType.setItem(this.consentPropertyName, "true");
  }

  get cookieStorage() {
    return {
      getItem: (item) => {
        const match = document.cookie.match(`(^|;)\\s*${item}\\s*=\\s*([^;]+)`);
        return match ? match.pop() : null;
      },
      setItem: (item, value, days = 180) => {
        const maxAge = days * 24 * 60 * 60;
        document.cookie = `${item}=${value}; path=/; max-age=${maxAge}`;
      },
    };
  }
}
